/**
 * RentalAgreement actions
 */
export enum RentalAgreementActionEnum {
	/**
	 * Set rental agreement status to pending
	 */
	PENDING = 'make_pending',
	/**
	 * Set rental agreement status to in progress
	 */
	IN_PROGRESS = 'make_in_progress',
	/**
	 * Set rental agreement status to completed
	 */
	COMPLETE = 'complete',
	/**
	 * Set rental agreement status to cancelled
	 */
	CANCEL = 'cancel',
	/**
	 * Create maintenance record linked to rental agreement
	 */
	CREATE_MAINTENANCE = 'create_maintenance',
	/**
	 * Create damage record linked to rental agreement
	 */
	CREATE_DAMAGE = 'create_damage',
	/**
	 * Check-in vehicle
	 */
	CHECK_IN = 'check_in',
	/**
	 * Check-out vehicle
	 */
	CHECK_OUT = 'check_out',
	/**
	 * Set rental agreement status to approved
	 */
	APPROVE = 'approve',
	/**
	 * Set rental agreement status to rejected
	 */
	REJECT = 'reject',
	/**
	 * Update the rental agreement's vehicle
	 */
	UPDATE_VEHICLE = 'update_vehicle',
	/**
	 * Update the rental agreement's vehicle category
	 */
	UPDATE_VEHICLE_CATEGORY = 'update_vehicle_category',
	/**
	 * Send payment link to customer via email
	 */
	SEND_PAYMENT_LINK = 'send_payment_link',
}
